import React from "react";
import page_not_found from "../assetes/page_not_found.png";
import { NavLink } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";

const PageNotFound404 = () => {
  return (
    <div>
      <Header />
      <div className="flex justify-center items-center flex-col h-full mt-28">
        <img src={page_not_found} />
        <div className="w-full">
          <NavLink to="/" className="cursor-pointer">
            <button className="border-2 rounded-md px-8 py-3 bg-red-200 font-semibold text-base">
              Go to home
            </button>
          </NavLink>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default PageNotFound404;
